import NavLink from "./navlink";

const ContactButton = ({ buttonType = "button", children }) => {

        return (
                <NavLink target="contact">
                        <button type={buttonType} className="text-black bg-sky-500 hover:bg-sky-700 focus:ring-4 w-full min-w-10 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-sky-500 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                                {children}
                        </button>
                </NavLink>
        )
}


export default ContactButton;